import React from "react";
import Uploader from "../components/Upload/UploadFiles";

function UploadFile({ setPageHeader }) {
  setPageHeader("Upload Files");
  return (
    <div>
      <Uploader />
    </div>
  );
}

export default UploadFile;
